// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"styles/colors.css\"","accent":"iPtW","primary":"wc1W","secondary":"_2_DM","zRed":"rgb(237, 85, 100)","zGreen":"#BFD730","center":"_3RNc","lineTitle":"_2yRi","heading1":"_1ABC","heading2":"_3JE6","heading3":"PQ1U","heading4":"_1VDA","heading5":"gIvX","heading6":"_142g","descrip1":"_1Ktw","descrip2":"_-2_Y","descrip3":"_2RUQ","descrip4":"SZAz","descrip5":"_3_Yp","divider":"_2Kh1","green":"_2TFT","grey":"_10YS","black":"_3TmB","white":"A_pW","warn":"_2qv5","pointer":"_3Jg7","noselect":"_2tZX","ellipsis":"_3Wlj","col-2":"_1Zsn","col-3":"_2gX6","col-4":"_1t54"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/components/Text/Text.scss
// module id = w3ns
// module chunks = 0